import whyData from "./why.json"
import whyData_ar from "./why_ar.json"
import { useLang } from "hooks/useLang"

// Import Swiper styles
import "swiper/css"
import "swiper/css/free-mode"

const F1WhyComponent = ({
    title,
    description,
    icon,
}: { title: string; description: string; icon: string }) => {
    return (
        <div className="flex flex-col gap-2 max-w-[300px]">
            <span className="flex flex-row gap-2 dark:text-white light:text-[#000] font-bold text-[22px] break-words">
                <img src={icon} alt={title} />
                {title}
            </span>
            <span className="dark:text-white light:text-[#000] text-[14px] font-light whitespace-normal break-words">
                {description}
            </span>
        </div>
    )
}

const RenderF1WhyComponent = () => {
    const { lang } = useLang()
    const data = lang === "ar" ? whyData_ar : whyData
    return (
        <div className="flex flex-row ">
            {data.map((item, index) => (
                <div key={index} className="w-[300px] min-w-[300px]">
                    <F1WhyComponent {...item} />
                </div>
            ))}


        </div>
    )
}

export default RenderF1WhyComponent
